import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';


export const usePlayMixStore = defineStore('playMixStore', () => {
  const selectedPlayServices = ref([]);
  const data = ref(null)
  const mixes = {}
  const selectedServices = ref([])
  const selectedPartners = ref([])
  const vasLimit = ref(null)
  const playPartners = ref([])
  const playMixMarketOffers = ref([])
  const playPromotionalContent = ref([])
  const mixVASLimits = ref([])
  const playMixDescriptions = ref([]);

  return {
    mixVASLimits,
    playPromotionalContent,
    playMixMarketOffers,
    playPartners,
    vasLimit,
    selectedPartners,
    selectedServices,
    data,
    selectedPlayServices,
    mixes,
    playMixDescriptions
  }
})
